import UserMiscForm from './UserMiscForm'

export default UserMiscForm
